export const LIST_MCU_PROJECT_NOTE_REQUEST = 'LIST_MCU_PROJECT_NOTE_REQUEST'
export const LIST_MCU_PROJECT_NOTE_SUCCESS = 'LIST_MCU_PROJECT_NOTE_SUCCESS'
export const LIST_MCU_PROJECT_NOTE_FAIL = 'LIST_MCU_PROJECT_NOTE_FAIL'

export const UPDATE_PROJECT_NOTE_STATUS_REQUEST =
  'UPDATE_PROJECT_NOTE_STATUS_REQUEST'
export const UPDATE_PROJECT_NOTE_STATUS_SUCCESS =
  'UPDATE_PROJECT_NOTE_STATUS_SUCCESS'
export const UPDATE_PROJECT_NOTE_STATUS_FAIL = 'UPDATE_PROJECT_NOTE_STATUS_FAIL'

export const CREATE_PROJECT_NOTE_REQUEST = 'CREATE_PROJECT_NOTE_REQUEST'
export const CREATE_PROJECT_NOTE_SUCCESS = 'CREATE_PROJECT_NOTE_SUCCESS'
export const CREATE_PROJECT_NOTE_FAIL = 'CREATE_PROJECT_NOTE_FAIL'

export const DELETE_PROJECT_NOTE_REQUEST = 'DELETE_PROJECT_NOTE_REQUEST'
export const DELETE_PROJECT_NOTE_SUCCESS = 'DELETE_PROJECT_NOTE_SUCCESS'
export const DELETE_PROJECT_NOTE_FAIL = 'DELETE_PROJECT_NOTE_FAIL'

export const DETAIL_MCU_PROJECT_NOTE_REQUEST = 'DETAIL_MCU_PROJECT_NOTE_REQUEST'
export const DETAIL_MCU_PROJECT_NOTE_SUCCESS = 'DETAIL_MCU_PROJECT_NOTE_SUCCESS'
export const DETAIL_MCU_PROJECT_NOTE_FAIL = 'DETAIL_MCU_PROJECT_NOTE_FAIL'
